// const salaryCompartments = [
//     {value: '', label: 'Wynagrodzenia'},
//     {value: '2500', label: '2001-2500'},
//     {value: '3000', label: '2501-3000'},
// ];

export const salaryCompartmentsGenerator = (employeesData)=>{

    const maxSalary = employeesData.reduce((currentHighest, employee)=>{
        if(currentHighest<+employee.wynagrodzenieKwota){
            return +employee.wynagrodzenieKwota
        } else {
            return currentHighest
        }
    },0);

    const salaryCompartments = [{value: '', label: 'Wynagrodzenia'}];
    let startValue = 2001;
    while(startValue<maxSalary){
        const compartmentPeak = startValue + 499;
        salaryCompartments.push(
            {value: `${compartmentPeak}`, label: `${startValue} - ${compartmentPeak}`},
        );
        startValue = startValue+500;
    }
    return salaryCompartments
};